<p-dropdown 
[options]="options" 
[optionLabel]="optionLabel" 
[placeholder]="placeholder" 
class="dropdown" 
[ngModel]="value" 
(ngModelChange)="onValueChange($event)" 
[virtualScroll]="virtualScroll" 
[virtualScrollItemSize]="virtualScrollItemSize"
></p-dropdown>/>
